import moment from 'moment'
import { v4 as uuidv4 } from 'uuid'
 
import { CloudwatchLogType } from 'src/data/common/type'
import { PrivateAppAPI } from '../common/PrivateAppAPI'

export class AwsService {
  logWebExceptions = async (log: CloudwatchLogType) => {
    const date = moment()
    const uuid = uuidv4()
    const data = {
      logEvents: 
      [
        {
          message: JSON.stringify({ uuid, ...log }),
          timestamp: date.valueOf(),
        },
      ]
    }

    const promise = await PrivateAppAPI.request({
      url: `/aws/cloudwatchLogs/logWebExceptions`,
      method: 'POST',
      data
    })
    return promise
  }
}

export const AwsApi = new AwsService()
